var countryCodes = {
    de: "+49",
    fr: "+33",
    es: "+34",
    it: "+39",
    nl: "+31",
    en: "+44"
};
var formats = [
    "national",
    "international",
    "url"
];
var formatPhoneNumber = function(phoneNumber, language, format) {
    if (format === "national") {
        if (!phoneNumber.startsWith("+")) {
            // is already national
            return phoneNumber;
        }
        return phoneNumber.replace(/^\+\d+\s/, "0");
    }
    var internationalPhoneNumber = phoneNumber.startsWith("+") ? phoneNumber : phoneNumber.replace("-", "").replace(/\s+/, " ").replace(/^0+/, "".concat(countryCodes[language], " "));
    if (format === "url") {
        return "tel:+".concat(internationalPhoneNumber.replace(/\D/g, ""));
    }
    return internationalPhoneNumber;
};
/**
 * Parses a phone number and returns different formats.
 * This is by no means a fully implemented phone number formatter, but
 * it covers the needs of FLOYT and all current phone numbers
 * provided by the Site Settings v1 API.
 */ var parsePhoneNumber = function(phoneNumber, language) {
    return Object.fromEntries(formats.map(function(f) {
        return [
            f,
            formatPhoneNumber(phoneNumber, language, f)
        ];
    }));
};
export { parsePhoneNumber };
